import { useState } from 'react'
import { makeGame } from '../../lib/games'

/**
 * Make something: one sentence in the family's own words. Describing it
 * carries the theme, the level and the reason at once, and themes are what
 * hold her attention. It lands at the top of the list below the moment it
 * is asked for, already making, and stays there a few minutes after it
 * comes back; nothing is lost if the page closes.
 */
export function MakeSomething({ childId, name }: { childId: string; name: string }) {
  const [text, setText] = useState('')
  const submit = () => {
    const prompt = text.trim()
    if (!prompt) return
    makeGame(childId, prompt)
    setText('')
    // The new row lands at the top of the list under this box; on a short
    // screen that is below the fold, so bring it up where the parent is looking.
    requestAnimationFrame(() => document.getElementById('games-now')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }))
  }
  return (
    <form
      className="make"
      onSubmit={(e) => {
        e.preventDefault()
        submit()
      }}
    >
      <label className="make-label" htmlFor="make-input">Make something for {name}</label>
      <div className="make-row">
        <textarea
          id="make-input"
          className="make-input"
          rows={2}
          value={text}
          placeholder={`A jellyfish game with ${name}'s name in it`}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault()
              submit()
            }
          }}
        />
        <button className="btn btn-primary make-go" type="submit" disabled={!text.trim()}>
          Make it
        </button>
      </div>
      <p className="make-hint">
        Sapling builds it around where {name} is and what she loves.
      </p>
    </form>
  )
}
